import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INAAction } from '../../model/ina-action';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LstQuestionValueDataView, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';



@Component({
  selector: 'app-adult-education',
  templateUrl: './adult-education.component.html',
  styleUrls: ['./adult-education.component.scss']
})
export class AdultEducationComponent implements OnInit {

  @Input('step') step: number;
  @Input('action') action: INAAction;
  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();

  frmOsy: UntypedFormGroup;
  section: Section;
  shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();

  constructor(
    private fb: UntypedFormBuilder,
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];

    this.frmOsy = this.fb.group({
      radioDroppedout: [],
      adultEducation: [],
      GED: [],
      HEP: [],
      Other: [],
      otherComments: [],
      adultEducationComments: []

    });
  }

  ngOnInit(): void {
    let sectionId: number = 24;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmOsy.dirty)
        this.setFormValue();
    });

    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    })

    if (this.action == INAAction.View) {
      this.frmOsy.disable();
    }
    else {
      this.frmOsy.valueChanges.subscribe(() => {
        this.updateChangeValue();
      });
    }
    this.Other.valueChanges.subscribe((value: any) => {
      if (value == true)
        this.otherComments.enable();
      else {
        this.otherComments.setValue('');
        this.otherComments.disable();
      }
    })

  }
  setFormValue() {
    this.getListQuestionValueData(365, 'Dropped out?')?.forEach(
      x => {
        if (x.Name == 'Yes' && x.Value == 'True')
          this.radioDroppedout.setValue("1");
        else if (x.Name == 'No' && x.Value == 'True')
          this.radioDroppedout.setValue("2");
      }
    );

    this.getListQuestionValueData(368, 'Enrolled in').forEach(
      x => {
        if (x.Name == 'Adult Education') {
          if (x.Value == 'True')
            this.adultEducation.setValue(true);
          else
            this.adultEducation.setValue(false);
        }
        else if (x.Name == 'GED') {
          if (x.Value == 'True')
            this.GED.setValue(true);
          else
            this.GED.setValue(false);
        }
        else if (x.Name == 'HEP') {
          if (x.Value == 'True')
            this.HEP.setValue(true);
          else
            this.HEP.setValue(false);
        }
        else if (x.Name == 'Other') {
          if (x.Value == 'True')
            this.Other.setValue(true);
          else {
            this.Other.setValue(false);
            this.otherComments.disable();
          }
        }
        else if (x.Name == 'Comments')
          this.otherComments.setValue(x.Value);
      }
    );

    this.adultEducationComments.setValue(this.getQuestionValue(375, 'Comments'));
  }


  getListQuestionValueData(questionId: number, questionName: string): LstQuestionValueDataView[] {
    {
      return this.shared.getListQuestionValueData(this.section, questionId, questionName);
    }

  }
  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }

  /*setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }

  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action: number) {
      let s: StepAction = new StepAction();
      s.stepNumber = 7;
      s.action = action == 1 ? '': this.notifyAction ;
      s.section = new Section();
      if (this.frmOsy.dirty) {
        this.updateChangeValue();
        s.section = this.section;
        s.lsttrackingHistory=this.lstTrackHistory;        
        this.lstTrackHistory=[];
      }
      this.prevOrNextStep.emit(s);

  }*/
  updateChangeValueLostFocus() {
    if (this.otherComments.dirty) {
      this.setListQuestionValue(368, "Comments", this.otherComments.value);
      this.otherComments.markAsPristine();
    }
    if (this.adultEducationComments.dirty) {
      this.setListQuestionValue(375, 'Comments', this.adultEducationComments.value);
      this.adultEducationComments.markAsPristine();
    }
  }

  updateChangeValue() {
    if (this.radioDroppedout.dirty) {
      let radioVal: string = '';
      radioVal = this.radioDroppedout.value;
      this.setRadioValue(365, 'Yes', radioVal);
    }
    if (this.adultEducation.dirty) {
      let radioVal: string = '';
      radioVal = this.adultEducation.value == 1 ? "True" : "False";
      this.setListQuestionValue(368, 'Adult Education', radioVal);
    }
    if (this.GED.dirty) {
      let radioVal: string = '';
      radioVal = this.GED.value == 1 ? "True" : "False";
      this.setListQuestionValue(368, 'GED', radioVal);
    }
    if (this.HEP.dirty) {
      let radioVal: string = '';
      radioVal = this.HEP.value == 1 ? "True" : "False";
      this.setListQuestionValue(368, 'HEP', radioVal);
    }
    if (this.Other.dirty) {
      let radioVal: string = '';
      radioVal = this.Other.value == 1 ? "True" : "False";
      this.setListQuestionValue(368, 'Other', radioVal);
    }


  }

  setRadioValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setRadioValue(this.section, questionId, value);
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
  }

  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }
  get radioDroppedout(): any { return this.frmOsy.get('radioDroppedout'); }
  get adultEducation(): any { return this.frmOsy.get('adultEducation'); }
  get GED(): any { return this.frmOsy.get('GED'); }
  get HEP(): any { return this.frmOsy.get('HEP'); }
  get Other(): any { return this.frmOsy.get('Other'); }
  get otherComments(): any { return this.frmOsy.get('otherComments'); }
  get adultEducationComments(): any { return this.frmOsy.get('adultEducationComments'); }


}
